// @flow

type VideoListItem = {|
  duration: number,
  height: number,
  thumbnail: string,
  url: string,
  width: number,
|};

export const VideoFormatEnum = {
  V_HLSV4: 'V_HLSV4',
  V_720P: 'V_720P',
};

type ValidVideoFormats = $Keys<typeof VideoFormatEnum>;

export type ScheduledPin = {|
  board: {
    name: string,
  },
  description: string,
  id: string,
  // For some reason it could happen that image is returned as null.
  // Need to make it optional to have more null check before use.
  image?: {
    '236x': {
      height: number,
      url: string,
      width: number,
    },
  },
  image_signature: string,
  link: string,
  scheduled_ts: number,
  title: string,
  user: {
    full_name: string,
    image_small_url: string,
    username: string,
  },
  videos?: {
    id: string,
    video_list: { [key: ValidVideoFormats]: VideoListItem },
  },
|};

export type DetailedScheduledPin = {|
  board: {
    name: string,
  },
  description: string,
  id: string,
  // For some reason it could happen that image is returned as null.
  // Need to make it optional to have more null check before use.
  image?: {
    '640x': {
      height: number,
      url: string,
      width: number,
    },
  },
  image_signature: string,
  link: string,
  scheduled_ts: number,
  title: string,
  user: {
    full_name: string,
    image_small_url: string,
    username: string,
  },
  videos?: {
    id: string,
    video_list: { [key: ValidVideoFormats]: VideoListItem },
  },
|};

export default null;
